import { useCallback, useState } from 'react';
import SyncDialogModal from '../SyncDialogModal/SyncDialogModal';
import { useTranslation } from 'react-i18next';
import { validateiOSAccountDetails, handleEmailValidation, handlePwdValidation } from './iOSAuthenticateHelper';
import { useSyncToCalendarProvider } from '../../providers/SyncToCalendarProvider';

const AppleAuthenticator = ({open , onClose, onAuthSuccess, availableEmailIds, linkedEmail}) => {
    const { t } = useTranslation();
    const syncToCalendarContext = useSyncToCalendarProvider();
    const [iOSAuthEmailId, setiOSAuthEmailId] = useState(linkedEmail || '');
    const [appleSpecificPwd, setAppleSpecificPassword] = useState('');
    const [emailErrorMsg, setEmailErrorMsg] = useState({ invalidError: false, alreadyExistsError: false });
    const [pwdErrorMsg, setPwdErrorMsg] = useState(false);
    const emailIds = availableEmailIds['apple']?.filter(em => em !== linkedEmail);

    const handleAuthorizeRequestBtn = useCallback(async () => {
        const response = await validateiOSAccountDetails(iOSAuthEmailId, appleSpecificPwd, syncToCalendarContext);
        const responseCode = response['errorCode'];
        const status = response['status'];
        if(status){
            onAuthSuccess(iOSAuthEmailId, appleSpecificPwd)
        }
        else{
            responseCode && handleEmailValidation(responseCode, setEmailErrorMsg);
            responseCode && handlePwdValidation(responseCode, setPwdErrorMsg);
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iOSAuthEmailId, appleSpecificPwd, onAuthSuccess]);

    const updateEmail = useCallback((val) => {
        if(emailIds.includes(val?.trim())) setEmailErrorMsg({ invalidError: false, alreadyExistsError: true });
        else {
            setEmailErrorMsg({ invalidError: false, alreadyExistsError: false });
        }
        setiOSAuthEmailId(val)
    }, [emailIds]);

    const updatePwd = useCallback((val) => setAppleSpecificPassword(val), []);

    const synciOSLoginOpenData = {
        title: t('myBlockMonth.syncToCalendar.syncToIOS'),
        description: t('myBlockMonth.syncToCalendar.syncToIOSText1'),
        descriptionSub: t('myBlockMonth.syncToCalendar.syncToIOSLearnHow'),
        actionLabel: t('myBlockMonth.syncToCalendar.syncCancel'),
        handleAction: onClose,
        inputId: t('myBlockMonth.syncToCalendar.syncToIOSId'),
        inputPwd: t('myBlockMonth.syncToCalendar.syncToIOSPassword'),
        secondaryActionLabel: t('myBlockMonth.syncToCalendar.syncToIOSAuthorize'),
        handleSecondaryAction: handleAuthorizeRequestBtn,
        modalInstruction: false,
        setEmailId: updateEmail,
        setAppleSpecificPassword: updatePwd,
        emailId: iOSAuthEmailId,
        appleSpecificPassword: appleSpecificPwd,
        emailErrorMsg,
        pwdErrorMsg,
        disableEmailInp: !!linkedEmail
    }

    return <SyncDialogModal open={open} onClose={onClose} data={synciOSLoginOpenData} />
};

export default AppleAuthenticator;